module.exports = "/dist/images/pl.accd67d8.png";